import React, { useEffect, useState } from 'react';
import { getFlows, deleteFlow } from '../services/flowService';
import { useNavigate } from 'react-router-dom';

function FlowListPage() {
  const [flows, setFlows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getFlows().then(setFlows);
  }, []);

  const handleLoad = (flow) => {
    // Redirigir al editor con datos podría requerir guardar en estado global o localStorage
    alert('Para cargar este flujo, implemente lógica de navegación con datos persistidos.');
  };

  const handleDelete = (id) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar este flujo?')) {
      deleteFlow(id).then(() => {
        setFlows((prev) => prev.filter((f) => f.id !== id));
      });
    }
  };

  return (
    <div className="section">
      <div className="container">
        <h1 className="title">Listado de Flujos Guardados</h1>
        <button className="button is-light mb-4" onClick={() => navigate('/')}>
          ← Volver al Editor
        </button>

        {flows.length === 0 ? (
          <p>No hay flujos disponibles.</p>
        ) : (
          <div className="table-container">
            <table className="table is-striped is-fullwidth">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Creado</th>
                  <th>Nodos</th>
                  <th>Conexiones</th>
                  <th>Tipo</th>
                  <th>Autor</th>
                  <th>Descripción</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {flows.map((flow) => (
                  <tr key={flow.id}>
                    <td>{flow.name}</td>
                    <td>{new Date(flow.createdAt).toLocaleString()}</td>
                    <td>{JSON.parse(flow.nodesJson || '[]').length}</td>
                    <td>{JSON.parse(flow.edgesJson || '[]').length}</td>
                    <td>{flow.type || '—'}</td>
                    <td>{flow.author || '—'}</td>
                    <td>{flow.description || '—'}</td>
                    <td>
                      <div className="buttons are-small">
                        <button className="button is-link" onClick={() => handleLoad(flow)}>Cargar</button>
                        <button className="button is-danger" onClick={() => handleDelete(flow.id)}>Eliminar</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default FlowListPage;
